import { useEffect } from 'react';

const useSingleTabEnforcer = (tabKey = 'instafix-app-tab-active') => {
    useEffect(() => {
        const tabId = Date.now().toString(); // Unique ID for this tab
        let broadcastChannel = null;

        const forceCloseTab = () => {
            window.location.href = 'about:blank'; // OR disable the UI instead
            alert('The application is already open in another tab!');
        };

        if ('BroadcastChannel' in window) {
            // Modern browsers → Use BroadcastChannel API
            broadcastChannel = new BroadcastChannel('single-tab-enforcer');

            // Inform other tabs that this one is active
            broadcastChannel.postMessage({ tabId });

            // Listen for messages from other tabs
            broadcastChannel.onmessage = (event) => {
                if (event.data.tabId !== tabId) {
                    forceCloseTab();
                }
            };
        } else {
            // Fallback for older browsers → Use LocalStorage method
            localStorage.setItem(tabKey, tabId);

            const handleStorageChange = (event) => {
                if (event.key === tabKey && event.newValue !== tabId) {
                    forceCloseTab();
                }
            };

            window.addEventListener('storage', handleStorageChange);

            window.addEventListener('beforeunload', () => {
                const currentTab = localStorage.getItem(tabKey);
                if (currentTab === tabId) {
                    localStorage.removeItem(tabKey);
                }
            });

            // Cleanup on unmount
            return () => {
                window.removeEventListener('storage', handleStorageChange);
            };
        }

        // Cleanup BroadcastChannel on unmount
        return () => {
            if (broadcastChannel) {
                broadcastChannel.close();
            }
        };
    }, [tabKey]);
};

export default useSingleTabEnforcer;